<template lang="pug">
  div.lmm-content-body-padded(:class="{ 'is-mobile': isMobile }")
    b-container(fluid)
      b-row
        div(slot="header").d-flex.justify-content-between.page-header
        b-container(v-if="visible" fluid)
          b-row.mb-3
            system-form(:form.sync="functionSet" @updateToggle="updateToggle")
          
          b-row.mb-3
            remote-form(:form.sync="functionSet" @updateToggle="updateToggle")
          
          b-row.mb-3
            connect-form(:form.sync="functionSet" @updateToggle="updateToggle")
          
          b-row.mb-3
            user-config-form(:form.sync="functionSet" @updateToggle="updateToggle")
          
          b-row.mb-3
            security-form(:form.sync="functionSet" @updateToggle="updateToggle")
          
          b-row.mb-3
            history-form(:form.sync="functionSet" @updateToggle="updateToggle")

          b-row.d-flex.justify-content-end
            b-btn.mt-2.mr-1.save-btn(@click="functionSubmit", size="sm" style="background-color: #EC7211;") {{$t('save')}}
            b-btn.mt-2(size="sm" style="") 취소
</template>

<script>
import _ from "lodash"
import Switches from "vue-switches"
import { user } from "@/api/access"
import { CompanyFunctionAPI, DeviceListAPI, RemoteAPI } from "@/api"
import { HeaderWithoutMenu } from "@/components/mixins/header"
import ToggleBox from "@/components/mixins/togglebox"

import SystemForm from "./components/system.vue"
import RemoteForm from "./components/remote.vue"
import ConnectForm from "./components/connect.vue"
import UserConfigForm from "./components/userConfig.vue"
import SecurityForm from "./components/security.vue"
import HistoryForm from "./components/history.vue"

export default {
  name: "function-settings",
  components: { SystemForm, RemoteForm, ConnectForm, UserConfigForm, SecurityForm, HistoryForm, HeaderWithoutMenu, ToggleBox, Switches },
  computed: {
    isMobile() {
      if (!this.$mq) return false
      if (this.$mq.resize && this.$mq.isMobile()) return true
      return false
    },
  },
  methods: {
    helpManager(ctx) {
      if (ctx == "os") {
        this.AppState.$emit("show-helpOTP-dialog", {
          title: "LinkMeMine",
          context: { path: "help_os" },
        })
      } else if (ctx == "vaccine") {
        this.AppState.$emit("show-helpOTP-dialog", {
          title: "LinkMeMine",
          context: { path: "help_vaccine" },
        })
      } else if (ctx == "password_change_limit") {
        this.AppState.$emit("show-helpOTP-dialog", {
          title: "LinkMeMine",
          context: { path: "help_PWChangeLimit" },
        })
      } else {
        this.AppState.$emit("show-helpOTP-dialog", {
          title: "LinkMeMine",
          context: { path: "help_os" },
        })
      }
    },
    updateAgent() {
      const company_fk = user().company_fk
      let params = {
        context: {
          path: "batch_update_desc",
          // args: { current_ver: this.device.dev_ver, latest_ver: this.device.latest_ver }
        },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "success",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key !== "submit") return
        RemoteAPI.put(`${company_fk}`, { type: "batch_update" }).then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "batch_update_requested" } })
        })
      })
    },
    functionSubmit() {
      this.validates.idle_timeout = this.isValidNum(this.validates.idle_timeout, this.functionSet.idle_timeout)
      this.validates.session_timeout = this.isValidNum(this.validates.session_timeout, this.functionSet.session_timeout)
      // this.validates.block_num = this.isValidNum(this.validates.block_num, this.functionSet.block_num)
      this.isValidPWChangeLimit(this.functionSet.password_change_limit)
      this.validates.min_os_major = this.isValidNum(this.validates.min_os_major, this.functionSet.min_os_major)
      this.validates.min_os_minor = this.isValidNum(this.validates.min_os_minor, this.functionSet.min_os_minor)
      this.validates.password_level = this.isValidNum(this.validates.password_level, this.functionSet.password_level)
      this.isValidVaccine()
      this.validates.agent_restart_time = this.isValidNum(this.validates.agent_restart_time, this.functionSet.agent_restart_time)
      this.validates.statistics_delete_period = this.isValidNum(this.validates.statistics_delete_period, this.functionSet.statistics_delete_period)

      // console.log(JSON.stringify(this.validates, 0, 2))

      const vd = this.validates
      if (!vd.idle_timeout) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_idle_time" },
        })
        return
      }
      if (!vd.session_timeout) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_session_time" },
        })
        return
      }
      // if (!vd.block_num) {
      //   this.AppState.$emit("show-message-dialog", {
      //     title: "LinkMeMine",
      //     context: { path: "invalid_block_num" },
      //   })
      //   return
      // }
      if (!vd.password_change_limit) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_password_change_limit" },
        })
        return
      }
      if (!vd.min_os_major) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_min_os_major" },
        })
        return
      }
      if (!vd.min_os_minor) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_min_os_minor" },
        })
        return
      }
      if (!vd.password_level) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_password_level" },
        })
        return
      }
      // if (!vd.agent_restart_time) {
      //   this.AppState.$emit("show-message-dialog", {
      //     title: "LinkMeMine",
      //     context: { path: "invalid_agent_restart_time" },
      //   })
      //   return
      // }
      if (!vd.statistics_delete_period) {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "invalid_agent_restart_time" },
        })
        return
      }
      let params = {
        manager_session_timeout: this.functionSet.manager_session_timeout,
        manager_idle_timeout: this.functionSet.manager_idle_timeout,
        session_timeout: this.functionSet.session_timeout,
        idle_timeout: this.functionSet.idle_timeout,

        os: this.functionSet.os,
        user_idle_limit: this.functionSet.user_idle_limit,

        record_upload_path: this.functionSet.record_upload_path,

        file_transfer: this.functionSet.file_transfer,
        block_num: this.functionSet.block_num,
        min_os_major: this.functionSet.min_os_major,
        min_os_minor: this.functionSet.min_os_minor,
        vaccine: this.functionSet.vaccine,
        capture: this.functionSet.capture,
        display_power_save: this.functionSet.display_power_save,
        system_power_save: this.functionSet.system_power_save,
        flag_security_agreement: this.functionSet.flag_security_agreement,
        agent_restart_time: this.functionSet.agent_restart_time,

        // 계정 보안 정책
        password_level: this.functionSet.password_level,
        login_failure_limit: this.functionSet.login_failure_limit,
        password_change_limit: this.functionSet.password_change_limit,
        self_unlock: this.functionSet.self_unlock,

        // 통계 이력 주기 설정
        statistics_delete_period: this.functionSet.statistics_delete_period,
      }
      CompanyFunctionAPI.post("", params).then(resp => {
        this.AppState.$emit("show-message-dialog", {
          title: "LinkMeMine",
          context: { path: "function-submit" },
        })
      })
    },
    isValidNum(model, valid) {
      if (/^[0-9]+$/.test(valid)) {
        model = true
      } else {
        model = false
      }
      return model
    },
    isValidVaccine() {
      this.functionSet.vaccine = this.functionSet.vaccine.replace(/^\s*/, "").replace(/\s*$/, "")
    },
    isValidPWChangeLimit(valid) {
      if (/^[0-9]+$/.test(valid) && valid <= 365) {
        this.validates.password_change_limit = true
      } else {
        this.validates.password_change_limit = false
      }
    },
    async getData() {
      const resp = await CompanyFunctionAPI.get()

      this.functionSet = Object.assign(this.functionSet, resp.data.objects[0])
      // this.functionSet.statistics_delete_period = String(this.functionSet.statistics_delete_period)
      this.visible = true
      return resp.data.objects
    },
    // async getDevice () {
    //   const resp=await DeviceListAPI.get()
    //   this.device = resp.data.objects
    //   return resp.data.objects
    // }

    updateToggle(key, value) {
      const params = {
        request_type: key,
        value: value ? "1" : "0",
      }
      CompanyFunctionAPI.put("", params).then(res => {
        // this.AppState.$emit("show-message-dialog", {
        //   title: "LinkMeMine",
        //   context: { path: "function-submit" },
        // })
      })
    },
  },

  mounted() {
    this.getData()
    // this.getDevice()
  },
  data() {
    return {
      visible: false,

      functionSet: {
        manager_session_timeout: 0,
        manager_idle_timeout: 0,
        session_timeout: null,
        idle_timeout: null,

        os: "win11",

        login_failure_limit: 0,
        user_idle_limit: 0,

        password_change_limit: 0,

        statistics_delete_period: 0,
        record_upload_path: null,

        flag_function_approval: false,
        flag_function_manager_approval: false,
        flag_function_agent_approval: false,
        enable_ip_policy: false,

        flag_function_rc: false,
        filetransfer: false,
        capture: false,
        flag_control_lock: false,
        flag_blackscreen: false,
        flag_screensaver: false,
        display_power_save: false,
        system_power_save: false,

        flag_windows_auto_update: false,
        flag_public_place_alert: false,
        public_place_alert: "",
        flag_security_agreement: false,
        flag_vaccine_check: false,
        flag_process_check: false,

        flag_function_2fa: false,
        self_unlock: false,

        block_num: null,
        min_os_major: null,
        min_os_minor: null,
        file_transfer: false,
        vaccine: null,
        password_level: null,
        agent_restart_time: null,
        process_check_list: "",
      },
      validates: {
        idle_timeout: false,
        session_timeout: false,
        block_num: false,
        password_change_limit: false,
        min_os_major: false,
        min_os_minor: false,
        password_level: false,
        agent_restart_time: false,
        statistics_delete_period: false,
      },
      timeOptions: [
        { value: "0", text: "00:00 - 01:00" },
        { value: "1", text: "01:00 - 02:00" },
        { value: "2", text: "02:00 - 03:00" },
        { value: "3", text: "03:00 - 04:00" },
        { value: "4", text: "04:00 - 05:00" },
        { value: "5", text: "05:00 - 06:00" },
        { value: "6", text: "06:00 - 07:00" },
        { value: "7", text: "07:00 - 08:00" },
        { value: "8", text: "08:00 - 09:00" },
        { value: "9", text: "09:00 - 10:00" },
        { value: "10", text: "10:00 - 11:00" },
        { value: "11", text: "11:00 - 12:00" },
        { value: "12", text: "12:00 - 13:00" },
        { value: "13", text: "13:00 - 14:00" },
        { value: "14", text: "14:00 - 15:00" },
        { value: "15", text: "15:00 - 16:00" },
        { value: "16", text: "16:00 - 17:00" },
        { value: "17", text: "17:00 - 18:00" },
        { value: "18", text: "18:00 - 19:00" },
        { value: "19", text: "19:00 - 20:00" },
        { value: "20", text: "20:00 - 21:00" },
        { value: "21", text: "21:00 - 22:00" },
        { value: "22", text: "22:00 - 23:00" },
        { value: "23", text: "23:00 - 24:00" },
      ],
      levelOption: [
        { value: "0", text: this.$t("password_level0") },
        { value: "1", text: this.$t("password_level1") },
        { value: "2", text: this.$t("password_level2") },
        { value: "3", text: this.$t("password_level3") },
      ],
      statisticsOption: [
        { value: "1", text: "30" + this.$t("day") },
        { value: "2", text: "60" + this.$t("day") },
        { value: "3", text: "90" + this.$t("day") },
        { value: "6", text: "6" + this.$t("month") },
        { value: "12", text: "1" + this.$t("year") },
        { value: "36", text: "3" + this.$t("year") },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .lmm-content-body-padded {
    padding: 0;
    margin: 0;
  }

  .btn {
    white-space: nowrap;
  }

  .row,
  .col,
  .container-fluid,
  .container {
    margin: 0;
    padding: 0;
  }

  .page-wrap {
    padding: 1rem 1.5rem;
  }

  //.page-header {
  //  padding: 0 1.5rem 0 1.5rem;
  //  margin-bottom: 0.8rem;
  //  height: 2rem;
  //}

  .title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .card {
    border-radius: 0;
    > .card-header {
      border-bottom: 1px solid #d2d2d2;
      font-size: 1.2rem;
      font-weight: 500;
    }
  }

  .list-group-item {
    padding-top: 0.45rem;
    padding-bottom: 0.45rem;
    border-right: 0;
    border-left: 0;
    &:last-child {
      border-bottom: 0;
    }
    // border: 1px solid #afafaf;
  }

  // .d-flex > .btn {
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   border: none;
  //   font-weight: 600;
  //   //color: black !important;
  //   width: 4rem;
  //   border-radius: 0;
  //   height: 1.5rem;
  // }

  .btn-secondary {
    color: black !important;
    font-weight: 400;
  }

  .btn-secondary:hover {
    color: black !important;
    background-color: #f7f7f7 !important;
    border: 1px solid #9c9c9c !important;
    font-weight: 400;
  }

  .btn-secondary:active {
    color: black !important;
    background-color: #cbcbcb !important;
    border: 1px solid #9c9c9c !important;
    font-weight: 400;
  }

  .save-btn {
    color: #000000 !important;
    background-color: #ff9900 !important;
    border: 1px solid #ff9900 !important;
    font-weight: 400;
  }

  .save-btn:hover {
    color: #000000 !important;
    background-color: #ec7211 !important;
    border: 1px solid #ff9900 !important;
    font-weight: 400;
  }
}

.is-mobile::v-deep {
  .contents {
    display: block !important;
    padding-top: 0;
    padding-bottom: 0;
  }
  .switch {
    width: 100%;
    padding: 10px 0;
    white-space: nowrap;
  }
  .msg {
    display: flex;
    flex-direction: column;
    button {
      margin-bottom: 10px;
    }
  }
}
</style>